{
  "CREATE_SEARCH_MODAL_TITLE": {
    "text": "Tallenna haku",
    "crowdinContext": "Create saved search modal header title"
  },
  "CREATE_MODAL_NAME_INPUT_LABEL": {
    "text": "Nimi",
    "crowdinContext": "Label of the name edit input for create modal"
  },
  "CREATE_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Tallenna",
    "crowdinContext": "Text of a button to confirm creation of a saved search"
  },
  "TOAST_SEARCH_CREATE_SUCCESS": {
    "text": "Haku tallennettu",
    "crowdinContext": "Toast message if saved search was successfully created"
  },
  "TOAST_SEARCH_CREATE_ERROR": {
    "text": "Haun tallentamisessa tapahtui virhe. Kokeile myöhemmin uudelleen.",
    "crowdinContext": "Toast message if an error occurred while creating saved search"
  },
  "SETTINGS_CHANNEL_NAME_WEB": {
    "text": "Tori",
    "crowdinContext": "Name of the channel for web notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_WEB": {
    "text": "Saat tiedon hakuvahtien uusista osumista Notifikaatiot-välilehdelle",
    "crowdinContext": "Description of the setting for Web notifications"
  },
  "SETTINGS_CHANNEL_NAME_PUSH": {
    "text": "Push",
    "crowdinContext": "Name of the channel for push notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_PUSH": {
    "text": "Saat hakuvahtien uudet osumat push-ilmoituksena puhelimeesi",
    "crowdinContext": "Description of the setting for Push notifications"
  },
  "SETTINGS_CHANNEL_NAME_EMAIL": {
    "text": "Sähköposti",
    "crowdinContext": "Name of the channel for email notifications"
  },
  "SETTING_CHANNEL_DESCRIPTION_EMAIL": {
    "text": "Saat hakuvahtien uudet osumat yhteenvetona sähköpostiisi kerran päivässä",
    "crowdinContext": "Description of the setting for Email notifications"
  },
  "SETTING_CHANNEL_TOGGLE_ARIA_LABEL": {
    "text": "Kytkin",
    "crowdinContext": "Aria label for notification toggle switch"
  },
  "NAME_INPUT_MAX_LENGTH_HELP_TEXT": {
    "text": "Max. 50 merkkiä",
    "crowdinContext": "Name input help text informing about max length"
  },
  "NAME_INPUT_EMPTY_HELP_TEXT": {
    "text": "Anna hakuvahdille nimi",
    "crowdinContext": "Name input help text informing about not leaving the name empty"
  },
  "DELETE_SEARCH_MODAL_TITLE": {
    "text": "Poista hakuvahti",
    "crowdinContext": "Delete saved search modal header title"
  },
  "DELETE_SEARCH_MODAL_DESCRIPTION": {
    "text": "Hakuvahti ja siihen liittyvät notifikaatiot poistetaan lopullisesti.",
    "crowdinContext": "Description informing user about deleting both saved search and its notification settings"
  },
  "DELETE_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Poista",
    "crowdinContext": "Text of a button to confirm deletion of a saved search"
  },
  "TOAST_SEARCH_DELETE_ERROR": {
    "text": "Hakuvahtia ei voitu poistaa, yritä uudelleen hetken kuluttua",
    "crowdinContext": "Toast message if an error occurred while deleting saved search"
  },
  "TOAST_SEARCH_DELETE_SUCCESS": {
    "text": "Haku poistettu",
    "crowdinContext": "Toast message if settings was successfully deleted"
  },
  "TOAST_SEARCH_UPDATE_SUCCESS": {
    "text": "Muutokset tallennettu",
    "crowdinContext": "Toast message if settings was successfully updated"
  },
  "CANCEL_BUTTON_TEXT": {
    "text": "Peruuta",
    "crowdinContext": "Cancel button text"
  },
  "RENAME_MODAL_NAME_INPUT_LABEL": {
    "text": "Hakuvahdin nimi",
    "crowdinContext": "Label of the name edit input for rename modal"
  },
  "RENAME_MODAL_CONFIRM_BUTTON_TEXT": {
    "text": "Tallenna",
    "crowdinContext": "Text of a button to confirm rename of a saved search"
  },
  "TOAST_SEARCH_RENAME_ERROR": {
    "text": "Nimeä ei voitu tallentaa, yritä uudelleen hetken kuluttua",
    "crowdinContext": "Toast message if an error occurred while renaming saved search"
  },
  "TOAST_SEARCH_NOTIFICATION_EDIT_ERROR": {
    "text": "Muutoksia ei tallennettu",
    "crowdinContext": "Toast message if an error occurred while editing saved search notification"
  },
  "EDIT_MODAL_RENAME_BUTTON_TEXT": {
    "text": "Muokkaa nimeä",
    "crowdinContext": "Edit modal rename button text"
  },
  "EDIT_MODAL_FOOTER_DELETE_BUTTON_TEXT": {
    "text": "Poista hakuvahti",
    "crowdinContext": "Button text opening the saved search deletion modal"
  },
  "LOADING_MODAL_TEXT": {
    "text": "Pieni hetki, haetaan asetuksia",
    "crowdinContext": "Text displayed when loading re-fetched saved search"
  },
  "ERROR_MODAL_TITLE": {
    "text": "Virhe",
    "crowdinContext": "Error modal title displayed when saved search fails to load"
  },
  "ERROR_MODAL_INFO_RETRY_TEXT": {
    "text": "Asetuksia ei voitu hakea. Yritä uudelleen.",
    "crowdinContext": "Error modal information about failing to load a saved search and possibility to try again"
  },
  "ERROR_MODAL_RETRY_BUTTON_TEXT": {
    "text": "Yritä uudelleen",
    "crowdinContext": "Error modal retry button text"
  },
  "ERROR_MODAL_IMAGE_ALT_TEXT": {
    "text": "Virhe ladattaessa hakuvahtia",
    "crowdinContext": "Alt text for image displayed when loading the search fails"
  }
}